import { useEffect, useState, useCallback } from 'react';

// reducers
import { useSelector, useStore } from 'react-redux';
import { success, error as toastError } from 'hyc-store/reducers/toast';
import { selectDistribution, updateDistribution } from 'hyc-store/reducers/distribution';
import { selectCountry } from 'hyc-store/reducers/countries/countriesReducer';

// components
import { SelectYear } from 'shared/components';
import { SelectWeek } from 'shared/components';
import { SelectMonth } from 'shared/components';
import { PartnersCheckbox } from './partners-checkbox';
import { Button } from 'shared/components/bulma/button';
import { Modal, ModalContent, ModalControl } from 'shared/components/bulma/modal';

// functions
import { useToggle } from 'shared/functions';

import { UseToast } from 'shared/functions';

// helpers
import * as helper from '../helper';

const DEFAULT_MONTHS = [];
for (let index = 0; index < 12; index++) {
    const month = new Date(1, index).toLocaleString('en-GB', { month: 'long' });
    DEFAULT_MONTHS.push(month);
}
const DELIVERY_WEEKS = ['Week 1', 'Week 2', 'Week 3', 'Week 4'];

const ModalList = ({ modal, handleModal }) => {
    const store = useStore();
    const { month, year, data, partners } = useSelector(selectDistribution);
    const country = useSelector(selectCountry);

    const [loading, setLoading] = useToggle(false);
    const [week, setWeek] = useState(DELIVERY_WEEKS[0])
    const [listPartners, setListPartners] = useState(null);

    const reset = () => {
        handleModal(false);
    }

    const handle = async () => {
        setLoading(true);
        // TODO: generate the list
        try {
            const pickedPartners = listPartners.filter(p => p.picked).map(p => p.label);
            await helper.validation({ data, week, month, year, country, pickedPartners });

            await helper.createListByWeek({ week, month, year, country, pickedPartners });

            store.dispatch(success('Success!'));

        } catch (error) {
            store.dispatch(toastError(error.message));
        }

        setLoading(false);
        handleModal(false);

        window.open('/shipment-lists', '_blank');
    }

    const handleYear = (event) => {
        store.dispatch(updateDistribution({ year: event.target.value }));
    }

    const handlePickOption = (option) => {
        store.dispatch(updateDistribution({ month: option }));
    }

    const handleChange = (event) => {
        setWeek(event.target.value);
    }

    const handleCheckbox = (event) => {
        const { value } = event.target;

        setListPartners(value);
    }

    const getData = useCallback(async () => {
        const data = await helper.getData(year, month, country);

        store.dispatch(updateDistribution({
            data
        }));

    }, [month, country, year, store]);

    useEffect(() => {
        if (!listPartners) {
            if (partners) {
                const list = [];
                for (const p of partners) {
                    list.push({ label: p, picked: true });
                }
                setListPartners(list);
            }
        }
        if (!data) {
            getData()
        }

        UseToast();

    }, [listPartners, partners, getData, data]);

    if (!listPartners) { return null; }

    return (
        <Modal title="Create Shipment List" isActive={modal} handleAccept={handle} handleReject={reset}>
            <ModalContent>

                <div className="columns is-multiline">

                    <div className="column is-3">
                        <label className="label is-size-5 mt-3">Year</label>
                        <SelectYear onChange={handleYear} year={year} />
                    </div>

                    <div className="column">
                        <label className="label is-size-5 mt-3">Month</label>
                        <SelectMonth onChange={handlePickOption} month={month} months={DEFAULT_MONTHS} />
                    </div>

                    <div className="column is-6">
                        <label className="label is-size-5 mt-3">
                            <span className="has-tooltip-arrow has-tooltip-right" data-tooltip="Choose the partners for this shipment.">
                                Partners
                            </span>
                        </label>
                        <PartnersCheckbox onChange={handleCheckbox}
                            partners={listPartners}
                        />

                    </div>
                    <div className="column is-12">
                        <label className="label is-size-5 mt-3">Shipment Week</label>
                        <SelectWeek
                            name="week"
                            value={week}
                            onChange={handleChange} />

                    </div>
                    <button className="modal-close is-large" aria-label="close" onClick={reset}></button>
                </div>

            </ModalContent >

            <ModalControl>

                <Button className={`is-primary is-fullwidth ${loading}`} name="submit" onClick={handle}>
                    Generate the list
                </Button>
                <Button className={`is-2 ${loading}`} name="cancel" onClick={reset}>
                    Cancel
                </Button>

            </ModalControl>

        </Modal >
    );
}

export { ModalList };
